module.exports = __webpack_public_path__ + "static/media/game-success.16bde358.mp3";